import * as Yup from 'yup'

export const groupStatusValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required')
});